import { AllOrderDetails, OrderStage } from 'components/common/types'
import {
  ALL_ORDER_DETAILS_REQUEST,
  ALL_ORDER_DETAILS_SUCCESS,
  ALL_ORDER_DETAILS_FAILURE,
  SINGLE_ORDER_DETAILS_REQUEST,
  SINGLE_ORDER_DETAILS_SUCCESS,
  SINGLE_ORDER_DETAILS_FAILURE,
  UPDATE_ALL_ORDERS_FROM_SIGNALR,
  FETCH_ORDER_LIST_BY_BUTTON_SUCCESS,
  FETCH_ORDER_LIST_BY_BUTTON_REQUEST
} from '../constants'

type IOrderDetailReducer = {
  allOrders: {
    data: {
      pending: AllOrderDetails[]
      completed: AllOrderDetails[]
    }
    isLoading: boolean
    error: null | string
  }
  singleOrder: {
    data: any
    isLoading: boolean
    error: null | string
  }
  fetchOrdersByButton: {
    isLoading: boolean
    error: null | string
  }
}

const initialState: IOrderDetailReducer = {
  allOrders: {
    data: {
      pending: [],
      completed: []
    },
    isLoading: true,
    error: null
  },
  singleOrder: {
    data: {},
    isLoading: true,
    error: null
  },
  fetchOrdersByButton: {
    isLoading: false,
    error: null
  }
}

const OrderDetailsReducer = (
  state: IOrderDetailReducer = initialState,
  action
): IOrderDetailReducer => {
  switch (action.type) {
    case ALL_ORDER_DETAILS_REQUEST: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          isLoading: true
        }
      }
    }

    case SINGLE_ORDER_DETAILS_REQUEST: {
      return {
        ...state,
        singleOrder: {
          ...state.singleOrder,
          isLoading: true
        }
      }
    }

    case FETCH_ORDER_LIST_BY_BUTTON_REQUEST:
      return {
        ...state,
        fetchOrdersByButton: {
          ...state.fetchOrdersByButton,
          isLoading: true
        }
      }

    case FETCH_ORDER_LIST_BY_BUTTON_SUCCESS:
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          data: action.payload,
          error: null
        },
        fetchOrdersByButton: {
          isLoading: false,
          error: null
        }
      }

    case ALL_ORDER_DETAILS_SUCCESS: {
      return {
        ...state,
        allOrders: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      }
    }

    case SINGLE_ORDER_DETAILS_SUCCESS: {
      return {
        ...state,
        singleOrder: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      }
    }

    case ALL_ORDER_DETAILS_FAILURE: {
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          isLoading: false,
          error: action.payload
        }
      }
    }

    case SINGLE_ORDER_DETAILS_FAILURE: {
      return {
        ...state,
        singleOrder: {
          ...state.singleOrder,
          isLoading: false,
          error: action.payload
        }
      }
    }

    case UPDATE_ALL_ORDERS_FROM_SIGNALR:
      return {
        ...state,
        allOrders: {
          ...state.allOrders,
          data: {
            completed: state.allOrders.data.completed,
            pending: action.payload
          }
        }
      }

    default:
      return state
  }
}

export default OrderDetailsReducer
